/** Шаги линейки «Создание игр» (холст game). */

export const GAME_CREATION_PATH_SLUG = 'sozdanie_igr';

export const GAME_CREATION_STEPS = [
  {
    id: 'balls',
    title: 'Шарики, клики и мини-игры',
    lead: 'Круги, клики, гравитация и простые мини-игры на холсте.',
    konspekts: [{ slug: 'code-canvas-game', title: 'Конспект' }],
    practiceHref: '/work/canvas-game-01-point',
    practiceLabel: '39 заданий «Холст game: шарики»',
  },
  {
    id: 'play',
    title: 'Клавиши, спрайты и камера',
    lead: 'Герой слушает клавиши, на экране счёт, спрайты и камера.',
    konspekts: [
      { slug: 'code-canvas-game-play', title: 'Клавиши и HUD' },
      { slug: 'code-canvas-game-play-sprites', title: 'Спрайты и камера' },
    ],
    practiceHref: '/work/canvas-play-01-keys-right',
    practiceLabel: '33 задания «Холст game: управление»',
  },
  {
    id: 'arena',
    title: 'Вид сверху, лабиринты и частицы',
    lead: 'Вид сверху без гравитации, стены, лабиринт и частицы.',
    konspekts: [{ slug: 'code-canvas-game-arena', title: 'Конспект' }],
    practiceHref: '/work/canvas-arena-01-topdown-x',
    practiceLabel: '26 заданий «Холст game: арена»',
  },
];
